import React from "react";
import { useNoAuthHooks } from "../../../../../../../Hooks/hooks";
import { ICategory, IMenuListItem } from "../../../../../../../Interfaces/responseTypes";
import useLanguagesHooks from "../../../../../../../Components/Languages/setLanguage-hooks";
import { AccordeonArrow } from "../../../../../../../Assets/Icons";
import styles from "./categorySlider.module.scss";
import useCategorySlider from "./categorySlider-hook";
import { ArrowLeftIcon, ArrowRightIcon } from "../../../../../../../Components/IconComponents";

interface IProps {
    data: IMenuListItem[];
    onSelectCategory: (data: IMenuListItem) => void;
    selectedId: number | null;
}

const CategorySlider: React.FC<IProps> = ({ data, onSelectCategory, selectedId }) => {
    const { baseURL } = useNoAuthHooks();
    const { t, activeLanguage } = useLanguagesHooks();
    const { sliderRef, cardRefs, handleScroll } = useCategorySlider(selectedId);

    return (
        <div className={styles.sliderContainer}>
            <div
                className={`${styles.arrow} ${styles.left}`}
                onClick={() => handleScroll('left')}
            >
                <ArrowLeftIcon color="var(--primary-hover)" />
                {/* <img
                    src={AccordeonArrow}
                    alt="leftArrow.svg"
                    className={styles.leftArrowIcon}
                /> */}
            </div>
            <div className={styles.slider} ref={sliderRef}>
                {data.map((item) => {
                    const localizedTitle =
                        item.category[`name_${activeLanguage}` as keyof ICategory] ||
                        item.category.name_en;

                    return (
                        <div
                            key={item.category.id}
                            ref={(el) => (cardRefs.current[item.category.id] = el)}
                            className={
                                item.category.id === selectedId
                                    ? styles.selectedCard
                                    : styles.card
                            }
                            onClick={() => onSelectCategory(item)}
                        >
                            <div
                                className={styles.cardImage}
                                style={{
                                    backgroundImage: `url(${baseURL}${item.category.upload_image ?? item.category.default_image
                                        })`,
                                }}
                            >
                                <div className={styles.title}>
                                    <p>{String(localizedTitle)}</p>
                                </div>
                            </div>
                            {item.category.id === selectedId && (
                                <div className={styles.selectedBox}>
                                    <p>{t("Visitor.Current")}</p>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            <div
                className={`${styles.arrow} ${styles.right}`}
                onClick={() => handleScroll('right')}
            >
                {/* <img
                    src={AccordeonArrow}
                    alt="rightArrow.svg"
                    className={styles.rightArrowIcon}
                /> */}
                <ArrowRightIcon color="var(--primary-hover)" />
            </div>
        </div>
    );
};

export default CategorySlider;
